export default class LoadRoutingGroupAdmin {
  constructor(context) {
    this.context = context;
  }

  run() {
    if (this.context.stores.appFeatures.get().isEnabled('inboxManagement')) {
      this.context.gateways.agentProfile.requestAll();
      this.context.gateways.user.request();
      this.context.stores.agentProfiles.setLoading();
      this.context.stores.users.setLoading();
    }
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/routing_groups/load_routing_group_admin.js